<template>
  <lu-vbox>
    <PageTitle :title='$t("Permissions")' @togglePageTitle='togglePageTitle' />

    <el-tree
      :data="model"
      ref='permTree'
      style='margin:20px;'
      class='lu-flex menu-tree'
      :indent='0'
      node-key="id"
      default-expand-all
      :key='"tree-" + isEdit'
      :expand-on-click-node="false"
      :props="defaultProps"
    >

      <span class='menu-tree-row' slot-scope="{ node, data }">
        <template v-if='isEdit'>
          <span class='menu-tree-node-label'>
            <span>{{ indent(node.level - 1) }}</span>

            <el-input v-model='node.label' />

            <el-button type="text" size="mini" @click="() => append(data)"> <el-icon name='plus'/> </el-button>
            <el-button type="text" size="mini" @click="() => remove(node, data)"> <el-icon name='close'/> </el-button>
          </span>
        </template>
        <template v-else>
          <span class='menu-tree-node-label'>
            <span>{{ indent(node.level - 1) }}</span>
            <span>{{ node.label}} </span>
          </span>
          <span class='menu-tree-node-content' @click.stop >
            <lu-hbox>
              <el-checkbox :disabled='readonly' :label='$t("Access")' @change='e => onChangeAccess(data, e)' style='margin-right: 50px' v-model='data.isAllowed' />
              <lu-item v-for='perm in data.leaves' :key='perm.functionId'>
                <el-checkbox :disabled='readonly' :label='perm.label' @change='e => onChangeLeaf(perm, e)' style='margin-right: 50px' v-model='perm.isAllowed'/>
              </lu-item>
            </lu-hbox>

          </span>
        </template>
      </span>
    </el-tree>
  </lu-vbox>

</template>

<script>
import { LuHbox, LuVbox, LuItem } from 'lusis-ui'
import PageTitle from '@/components/PageTitle'

export default {
  name: 'PermissionTree',
  components: { PageTitle, LuHbox, LuVbox, LuItem },
  props: {
    tree: {
      type: Array,
      default: () => []
    },
    depth: {
      type: Number,
      default: 0
    },
    readonly: {
      type: Boolean,
      default: false
    },
    maxNodeId: {
      type: Number,
      default: 0
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    fontClass: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      model: this.tree,
      folded: {}
    }
  },
  computed: {
    defaultProps () {
      return {
        children: this.isEdit ? 'originChildren' : 'children'
      }
    }
  },
  watch: {
    tree: function () {
      this.model = this.tree
    }
  },
  created () {
  },
  methods: {
    togglePageTitle () {
    },
    append (data) {
      const newChild = { id: this.maxNodeId++, label: '', children: [], new: true }
      if (!data.children) {
        this.$set(data, 'children', [])
      }
      data.children.push(newChild)
    },
    remove (node, data) {
      const parent = node.parent
      const children = parent.data.children || parent.data
      const index = children.findIndex(d => d.id === data.id)
      children.splice(index, 1)
    },
    indent: function (j = 0) {
      let indent = ''
      for (let i = 0; i < j; i++) {
        indent += '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0'
      }
      return indent
    },
    disallowRec: function (node, first) {
      if (!first) node.isAllowed = false
      for (let i = 0; i < node.children.length; i++) {
        this.disallowRec(node.children[i], false)
      }
      for (let i = 0; i < node.leaves.length; i++) {
        this.disallowRec(node.leaves[i], false)
      }
    },
    allowRec: function (node, first) {
      if (!first) node.isAllowed = true
      if (node.parent) this.allowRec(node.parent, false)
    },
    onChangeAccess: function (node, val) {
      if (!val) this.disallowRec(node, true)
      if (val) this.allowRec(node, true)
    },
    onChangeLeaf: function (node, val) {
      if (val) this.allowRec(node, true)
    },
    getModel: function () {
      return this.model
    }
  }
}
</script>

<style >
.el-tree-node:focus {
  outline-color: transparent !important;
}
</style>
